/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Cookie from 'js-cookie';
import sha1 from 'psa-core/util/sha1';

import Session from '@/Session';
import Config from '@config/Config';
// import ClearAuthenticationCookies from '@/services/ClearAuthenticationCookies';

import GetOTDSTicketByUsernamePassword from './GetOTDSTicketByUsernamePassword';
import GetSAMLAssertionByOTDSTicket from './GetSAMLAssertionByOTDSTicket';

export default async function HandleOTDSRESTAuthentication(username, password, code) {
  const samlCookieName = Config.getSamlArtifactCookieName();
  const checkCookieName = Config.getCheckCookieName();
  const cookiesPath = Config.getSamlArtifactCookiePath();

  // await ClearAuthenticationCookies();

  const ticketObj = await GetOTDSTicketByUsernamePassword(username, password);
  const artifact = await GetSAMLAssertionByOTDSTicket(ticketObj.ticket);

  Cookie.set(samlCookieName, artifact, { path: cookiesPath });

  const ct = sha1.hex_sha1(artifact);
  Cookie.set(checkCookieName, ct, { path: cookiesPath });

  Session.auth = {
    samlArtifact: artifact,
    checkValue: ct
  };
}
